import React from "react";
import { clearAll, clearOne } from "../lib/cf";

const FIELD_LABELS = {
	cancerOrgans: "Cancer Organs",
	cancerTypes: "Cancer types",
	sex: "Sex",
	ageBuckets: "Age",
	years: "Publication year",
	metastaticPatterns: "Metastatic patterns",
	biomarkerTypes: "Biomarker class",
	clinicalResponse: "Clinical response",
	biomarkerGenes: "Biomarker",
	biomarkerMeasurements: "Biomarker details",
	countries: "Countries",
	kaplanMeier: "Time on treatment",
	drugTypes: "Treatment class",
	drugName: "Treatment details",
	drugCategory: "Drug category",
	bestResponse: "Best clinical response",
	reasonForDiscontinuation: "Reason for discontinuation",
	discAEItems: "Discontinuation AEs",
	otherAEItems: "Other AEs",
	drugNames: "Treatment details",
	discAE: "Discontinuation due to AE",
	aeGrade: "AE Grade",
	adverseEvents: "Adverse Events",
	manuscriptIds: "Manuscripts",
};

const MAX_TITLE_LENGTH = 20;

export default function FiltersBar({ filters, setFilters, manuscriptTitles }) {
	//manuscript chips show a shortened title instead of the id
	const chipLabel = (field, v) => {
		if (field !== "manuscriptIds") return v;
		const title = manuscriptTitles?.get(v);
		if (!title) return `#${v}`;
		return title.length > MAX_TITLE_LENGTH ? title.substring(0, MAX_TITLE_LENGTH) + "…" : title;
	};

	const entries = Array.from(filters.entries())
		.map(([field, set]) => [field, Array.from(set || [])])
		.filter(([, arr]) => arr.length);

	if (!entries.length) return null;

	return (
		<div className="filters-bar">
			<div className="filters-bucket">
				{entries.map(([field, values], groupIndex) => (
					<React.Fragment key={field}>
						{groupIndex > 0 && <span className="filter-operator">AND</span>}
							<div className="filter-group">
								<span className="group-label">{FIELD_LABELS[field] || field}: </span>
								{values.map((v, index) => (
									<React.Fragment key={v}>
									{index > 0 && <span className="filter-operator-inline">OR</span>}
									<button
										className="chip"
										onClick={() => clearOne(filters, setFilters, field, v)}
										title={field === "manuscriptIds" ? `Remove: ${manuscriptTitles?.get(v) || v}` : "Remove"}
									>
										{chipLabel(field, v)} ✕
									</button>
									</React.Fragment>
								))}
							</div>
					</React.Fragment>
				))}
			</div>

			<button className="chip danger" onClick={() => clearAll(setFilters)}>
				Clear all
			</button>
		</div>
	);
}
